










import { Component, Vue, Ref } from 'vue-property-decorator';
import SimplifiedWorkRelationPaycheckLineTemplateForm from '@/components/PaycheckLineTemplate/SimplifiedWorkRelationPaycheckLineTemplateForm.vue';
import i18n from '@/i18n';
import { UnsavedChanges } from '@/decorators/unsaved-changes';
import unitPaycheckLineTemplateRequiredGuard from '@/guards/unit-paycheck-line-template-required-guard';
import permissionGuard from '@/guards/permission-guard';

@Component({
  components: {
    SimplifiedWorkRelationPaycheckLineTemplateForm,
  },
  beforeRouteEnter: (to, from, next) => {
    permissionGuard('canEditEmployees', to, from, next)
      .then(() => {
        unitPaycheckLineTemplateRequiredGuard(to, from, next);
      }).catch(router => {
        router.push({ name: 'Dashboard' });
        router.app.$sMessage.error(router.app.$t('noPermissions'));
      });
  },
})
export default class SimplifiedPaycheckTemplate extends Vue {
  @Ref() private readonly formRef!: SimplifiedWorkRelationPaycheckLineTemplateForm;
  @UnsavedChanges<SimplifiedPaycheckTemplate>({
    messages: {
      // i18n.t used instead of this.$t because function is async and component calling it might be destroyed, making 'this' undefined
      entity: i18n.t('SimplifiedPaycheckTemplate.name'),
    },
    saveAndContinue() {
      return this.formRef && this.formRef.saveAndContinue();
    },
  }) private dirtyForm = false;
}
